import React from 'react';
import { Flex } from '@radix-ui/themes';
import ResourceLink from '../ResourceLink';
import { RiskIndicator } from '../RiskIndicator';
import { EntityDisplayFragment } from './EntityDisplay.generated';


/**
 * Component for displaying entities with optional risk icons
 * Wraps ResourceLink and adds RiskIndicator when entity has risks
 */
export function EntityDisplay({ id, name, risks }: EntityDisplayFragment) {
  return (
    <Flex align="center" gap="2">
      <ResourceLink
        id={id}
        name={name}
        path="/entities"
      />
      <RiskIndicator risks={risks} />
    </Flex>
  );
}
